import Header from "./components/Header";
import Leaderboard from "./components/Leaderboard";

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <Header />
      <main className="px-4 py-8">{<Leaderboard />}</main>
    </div>
  );
}

export default App;
